import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { XMarkIcon } from '@heroicons/react/24/outline';

export const showToast = {
    success: (message: string) => {
        toast.success(message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            className: "bg-green-50 text-green-800 border border-green-200 font-medium",
        });
    },
    error: (message: string) => {
        toast.error(message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            className: "bg-red-50 text-red-800 border border-red-200 font-medium",
        });
    },
    warning: (message: string) => {
        toast.warning(message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            className: "bg-yellow-50 text-yellow-800 border border-yellow-200 font-medium",
        });
    }
};

export const CustomToastContainer = () => {
    return (
        <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            className="mt-16"
            toastClassName="!bg-white !shadow-lg !rounded-lg !border !border-gray-200"
            progressClassName="!bg-gray-800"
            closeButton={({ closeToast }: { closeToast: () => void }) => (
                <button
                    onClick={closeToast}
                    className="text-gray-400 hover:text-gray-500 focus:outline-none"
                >
                    <XMarkIcon className="h-5 w-5" />
                </button>
            )}
        />
    );
}; 